module.exports = __webpack_public_path__ + "img/bgSusan@2x.35072661.jpg";